import React from 'react';
import { translate } from 'react-i18next';

class BrandFooter extends React.Component {
  constructor(props) {
    super(props);
  }

  toTitleCase(str) {
    return str.replace(/\w\S*/g, txt => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase());
  }

  render() {
    const footerClass = `brand-footer ${this.props.brand}`;
    return (
      <footer className={footerClass}>
        <nav id="brand_footer">
          {window.EmployeeWeb.ENVConfig.brand === 'adp' &&
            <ul>
              <li>{this.props.t('BrandFooter.copyright_adp', { year: new Date().getFullYear() })}</li>
              <li><a href={this.props.privacyLink} target="_blank">{this.props.t('BrandFooter.privacy')}</a></li>
              <li><a href={this.props.termsLink} target="_blank">{this.props.t('BrandFooter.legal')}</a></li>
            </ul>
          }
          {window.EmployeeWeb.ENVConfig.brand === 'jonas' &&
            <ul>
              <li>{this.props.t('BrandFooter.powered_by_jonas')}</li>
              <li><a target="_blank" href={this.props.privacyLink}>{this.props.t('BrandFooter.privacy_policy')}</a></li>
            </ul>
          }
          {!['adp', 'jonas'].includes(window.EmployeeWeb.ENVConfig.brand) &&
            <ul>
              <li>&copy; {this.props.year} {this.toTitleCase(this.props.brand)}, Inc. {this.props.t('BrandFooter.all_rights_reserved')}</li>
              <li><a href={this.props.privacyLink} target="_blank">{this.props.t('BrandFooter.privacy_policy')}</a></li>
              <li><a href={this.props.termsLink} target="_blank">{this.props.t('BrandFooter.terms_of_use')}</a></li>
            </ul>
          }
        </nav>
      </footer>
    );
  }
}

export default translate()(BrandFooter);
